import "./drawer.scss";
import "./modal.scss";
import "./pagination.scss";
import "./radio.scss";
import "./datePicker.scss";
// import "./checkbox.scss";
import "./form.scss";
import "./switch.scss";

// 新增
import "./segmented.scss";
import "./select.scss";
import "./table.scss";
import "./popover.scss";
import "./inputNumber.scss";
import "./scrollbar.scss";
import "./input.scss";
import "./badge.scss";
import "./message.scss";
import "./tooltip.scss";
